/**
 * Selector for the charging mode.
 * @module
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { ChargingMode } from "../../data/models/ChargingMode";
import { Button } from "reactstrap";
import { MdEco, MdElectricalServices, MdElectricCar, MdOfflineBolt, MdWbSunny } from "react-icons/md";
import '../../styles/schedule.scss';
import { useFormContext } from 'react-hook-form';
import * as Types from "../../App";
import ModeButton from '../styled/ModeButton';
import { Grid, ToggleButton, ToggleButtonGroup } from '@mui/material';

/**
 * State of the selector.
 * @field mode      Charging mode, or null if not selected
 * @field setMode   Setter for mode
 */
interface Mode {
    settings: Types.SessionType;
    setSettings: React.Dispatch<React.SetStateAction<Types.SessionType>>,
}

// Selector for Fast mode or Smart mode
export default function ModeSelector() {
    const context = useFormContext();
    const [mode, setMode] = useState<ChargingMode | null>(context.getValues("mode") || ChargingMode.Smart);

    // Perform this action every time one of the dependencies changes
    useEffect(() => {
        context.setValue("mode", mode);
    }, [context, mode])

    // Set a CSS class based on being selected or deselected
    const fast: string = mode === ChargingMode.Fast ? "selected" : "deselected";
    const smart: string = mode === ChargingMode.Smart ? "selected" : "deselected";

    //const [previousMode, setPreviousMode] = useState<ChargingMode | null>();

    function calculateMode(selectedMode) {
        if (selectedMode !== null) {
            setMode(selectedMode);
            context.setValue("mode", mode);
        }
    }

    // Body of the component
    return (
        <Grid container
            direction="row"
            alignItems="center"
            justifyContent="center"
            gap={5}
            marginTop="1rem"
            >
            <ToggleButtonGroup 
            value={mode} 
            color="success" 
            exclusive
            onChange={(e, selected) => calculateMode(selected)}
            sx={{
               
                '.MuiToggleButtonGroup-grouped': {
                    borderRadius: '15px',
                    textTransform: 'none',
                    fontWeight: '800',
                    fontFamily: 'Open Sans',
                    border: '2px solid',
                    padding: '7px',
                    ':not(:last-of-type)' : {
                        borderRadius: '13px',
                        marginRight: '1rem'
                        
                    },
                    ':not(:first-of-type)': {
                        borderRadius: '13px',
                        border: '2px solid',
                        marginLeft: '1rem'
                    }
                },
                
                '.Mui-selected': {
                    // color: '#77c768',
                    borderColor: '#77c768'
                },
            }}
            >
                <ToggleButton value={ChargingMode.Fast}> Fast Charge&nbsp;<MdElectricalServices size={20}/> </ToggleButton>
                <ToggleButton value={ChargingMode.Smart}> Eco Charge&nbsp;<MdEco size={20}/> </ToggleButton>
            </ToggleButtonGroup>
            {/* <ModeButton onClick={() => {setMode(ChargingMode.Fast);  }} text="Fast Charge" />
            <ModeButton onClick={() => setMode(ChargingMode.Smart)} text="Eco Charge" /> */}
        </Grid>
                    
    );
}